import {get} from 'lodash';

export default (
  state = {},
  {userId, teams, coaches, rankPerformance, closeToRank, bonuses, atRisk}: any,
) => {
  return {
    ...state,
    allTeams: {
      ...get(state, 'allTeams', {}),
      [userId]: {teams, coaches, rankPerformance, closeToRank, bonuses, atRisk},
    },
  };
};
